<template> 
    <div class="favorite-other-items" v-if="filterCMSparams != null">
        <div class="favorite-list-table" :class="cardID" v-if="!isMobileChecker">
            <ul v-if="cardID == 'favoriteFlats'">
                <li>{{ filterCMSparams.words_translation.plan_name }}</li>
                <li>{{ filterCMSparams.words_translation.rooms }}</li>
                <li>{{ filterCMSparams.words_translation.project }}</li>
                <li>{{ filterCMSparams.words_translation.class }}</li>
                <li>{{ filterCMSparams.words_translation.part }}</li>
                <li>{{ filterCMSparams.words_translation.size }}</li>
                <li>{{ filterCMSparams.words_translation.price }}</li>
            </ul>
            <ul v-if="cardID == 'favoriteParking' || cardID == 'favoriteStoreRooms'">
                <li>{{ filterCMSparams.words_translation.project }}</li>
                <li>{{ filterCMSparams.words_translation.part }}</li>
                <li>{{ filterCMSparams.words_translation.class }}</li>
                <li>{{ filterCMSparams.words_translation.level }}</li>
                <li>{{ filterCMSparams.words_translation.size }}</li>
                <li>{{ filterCMSparams.words_translation.price }}</li>
            </ul>
            <ul v-if="cardID == 'favoriteCommerce'">
                <li>{{ filterCMSparams.words_translation.project }}</li>
                <li>{{ filterCMSparams.words_translation.part }}</li>
                <!-- <li>{{ filterCMSparams.words_translation.class }}</li> -->
                <li>{{ filterCMSparams.words_translation.level }}</li>
                <li>{{ filterCMSparams.words_translation.size }}</li>
                <li>{{ filterCMSparams.words_translation.price }}</li>
            </ul>
        </div>

        <div class="other-items-list" :class="cardID">
            <div class="other-item" v-for="item in favoriteItems">
                <component :is="cardID == 'favoriteFlats' || cardID == 'favoriteCommerce' ? 'router-link' : 'div'" class="link-to-page" 
                :to="{'name': cardID == 'favoriteFlats' ?  'flats-card' : 'commerce-card', params:{'id' : item.id}}">
                    <div class="item-head-mobile" v-if="isMobileChecker">
                        <div class="info-value info-value-price">{{ getNumber(item.price_full) }} тг</div>
                        <div class="info-value info-value-project">{{ item.project.name }}</div>
                        <div class="info-value info-value-part">{{ parseInt(item.part.label) }} {{ filterCMSparams.words_translation.part }}</div>
                        <div class="value-item-img" v-if="cardID == 'favoriteFlats'">
                            <img :src="item.plan" alt="" v-if="item.plan != null && item.plan != ''">
                            <svgIcon name="none-img" class="icon-none-img" v-else/>
                        </div>
                    </div>
                    <ul>
                        <li v-if="!isMobileChecker && cardID == 'favoriteFlats'">
                            <div class="item-img">
                                <img :src="item.plan" alt="" v-if="item.plan != null && item.plan != ''">
                                <svgIcon name="none-img" class="icon-none-img" v-else/>
                            </div>
                        </li>
                        <li v-if="cardID == 'favoriteFlats'">
                            <div class="info-value">
                                <span v-if="item.rooms.value == '0'">Студия</span>
                                <span v-if="item.rooms.value == '1'">{{ item.rooms.label }} комната</span>
                                <span v-if="item.rooms.value != '0' && item.rooms.value != '1'">{{ item.rooms.label }} комнаты</span>
                            </div>
                        </li>
                        <li v-if="!isMobileChecker">
                            <div class="info-value info-value-project">{{ item.project.name }}</div>
                        </li>
                        <li v-if="cardID == 'favoriteFlats'">
                            <div class="info-value">{{ item.class.name }}</div>
                        </li>
                        <li v-if="!isMobileChecker">
                            <div class="info-value">{{ parseInt(item.part.label) }}</div>
                        </li>
                        <!-- <li v-if="cardID == 'favoriteCommerce'">
                            <div class="info-value">{{ item.type.name }}</div>
                        </li> -->
                        <!-- Для паркингов -->
                        <li v-if="cardID == 'favoriteParking' || cardID == 'favoriteStoreRooms'">
                            <div class="info-value">{{ item.type.label }}</div> 
                        </li>
                        <li v-if="cardID == 'favoriteParking' || cardID == 'favoriteStoreRooms' || cardID == 'favoriteCommerce'">
                            <div class="info-value">{{ item.level }} <span v-if="isMobileChecker">ур.</span></div> 
                        </li>
                        <!-- end Для паркингов -->
                        <li>
                            <div class="info-value size-value">{{ item.size }} <span v-if="isMobileChecker">м²</span></div>
                        </li>
                        <li v-if="!isMobileChecker">
                            <div class="info-value price-value">{{ getNumber(item.price_full) }} тг</div>
                        </li>
                    </ul>
                    <button class="remove-favorite-item-btn" @click.prevent="removeFromFavorite(item)"><svgIcon name="close" class="icon-close"/></button>
                </component>
            </div>
        </div>
        <!-- {{ favoriteItems }}<br><br><br><br>{{ filterCMSparams }} -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'favorite-sales-items',
        props: ['favoriteItems'],
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                cardID: this.$route.name,
            }
        },
        computed: mapGetters({
            favoritePage: 'loadFavoritePage',
            filterCMSparams: 'loadFilterCMSparams',
            isMobileChecker: 'loadIsMobileChecker',
            favoriteLocalStorageUpdate: 'loadFavoriteLocalStorageUpdate',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            removeFromFavorite(arr) {
                // console.log(arr)
                const localStorageKeys = {
                    'favoriteFlats': 'favorite_flats_dial',
                    'favoriteParking': 'favorite_parking_dial',
                    'favoriteStoreRooms': 'favorite_storerooms_dial',
                    'favoriteCommerce': 'favorite_commerce_dial'
                };
                const localStorageKey = localStorageKeys[this.cardID];
                if (localStorageKey) {
                    var favorites = JSON.parse(localStorage.getItem(localStorageKey));
                    favorites = favorites.filter(favorite => favorite.id != arr.id);
                    localStorage.setItem(localStorageKey, JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                }
            },
        },
        created () {
            
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite-page/favorite-other-items.scss';
    @import '@/styles/components/favorite-page/respond/favorite-other-items-respond.scss';
</style>